







































import BaseComponent from "@/components/base/BaseComponent";
import {MemberType} from "@/components/dashboard/process-management/model/ProcessManagmentTypes";
import {v4 as uuidv4} from "uuid";
import {Component, Prop} from 'vue-property-decorator';

@Component({
})
export default class LegallyWithdrawingFunds extends BaseComponent {

  private uniqueId = uuidv4();

  private loanRadioSelection: number | null = 0; // Default to 0
  private loanRadioSelectionStrValue: string = "0"; // Default to '0'

  private onRadioChange(value: number): void {
    this.loanRadioSelection = value;

    if (value === 0) {
      this.loanRadioSelectionStrValue = "0";
    }

    this.$emit("handleChange", value, this.loanRadioSelectionStrValue);
  }


  clearRadioChoice() {
    this.loanRadioSelection = null
  }
}
